export const ADVERTISING_KEYS = Object.freeze([
  'gclid', 'gbraid', 'wbraid',
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
]);
export const ATTRIBUTION_STORAGE_KEY = 'cargotetris.advertising.v1';
const ALLOWED_HOSTS = new Set(['cargotetris.com', 'www.cargotetris.com', 'app.cargotetris.com']);
// Per-window fallback if storage is blocked; localStorage persists across reloads.
const memory = new WeakMap();

const cleanParameters = (value) => Object.fromEntries(
  ADVERTISING_KEYS.filter((key) => typeof value?.[key] === 'string' && value[key].trim())
    .map((key) => [key, value[key]])
);

// Keep the first non-empty value of each supported parameter across page loads.
export const getAdvertisingParameters = (browser = globalThis.window) => {
  if (!browser) return {};
  let saved = memory.get(browser) || {};
  try {
    saved = { ...cleanParameters(JSON.parse(browser.localStorage.getItem(ATTRIBUTION_STORAGE_KEY))), ...saved };
  } catch {
    // Storage may be unavailable or contain invalid JSON; links must still work.
  }
  const query = new URLSearchParams(browser.location.search);
  const parameters = { ...saved };
  // Only fill missing keys: a new visit must not replace first-touch values.
  Object.entries(cleanParameters(Object.fromEntries(query))).forEach(([key, value]) => {
    if (parameters[key] === undefined) parameters[key] = value;
  });
  memory.set(browser, parameters);
  try {
    if (Object.keys(parameters).length) {
      browser.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(parameters));
    }
  } catch {
    // The in-memory copy still covers this page when storage is blocked.
  }
  return { ...parameters };
};

export const addAdvertisingParameters = (href, parameters, baseUrl) => {
  if (!href || href.trim().startsWith('#')) return href;
  let url;
  try {
    url = new URL(href, baseUrl);
  } catch {
    // Invalid links or base URLs must not break navigation or processing other links.
    return href;
  }
  if (!['http:', 'https:'].includes(url.protocol) || !ALLOWED_HOSTS.has(url.hostname)) return href;
  let changed = false;
  Object.entries(cleanParameters(parameters)).forEach(([key, value]) => {
    if (!url.searchParams.has(key)) {
      url.searchParams.set(key, value);
      changed = true;
    }
  });
  return changed ? url.href : href;
};
